<template>
  <div class="MyBookings panel">
    <h4>My bookings</h4>
    <div class="body">
      <div class="status new">
        <div class="label">
          New
        </div>
        <div class="count">
          {{ bookings.new.totalCount }}
        </div>
      </div>

      <div class="status assigned">
        <div class="label">
          Assigned
        </div>
        <div class="count">
          {{ bookings.assigned.totalCount }}
        </div>
      </div>

      <div class="status completed">
        <div class="label">
          Completed
        </div>
        <div class="count">
          {{ bookings.delivered.totalCount }}
        </div>
      </div>

      <div class="status cancelled">
        <div class="label">
          Cancelled
        </div>
        <div class="count">
          {{ bookings.cancelled.totalCount }}
        </div>
      </div>
    </div>

    <div class="footer">
      <IconButton
        icon="calendar"
        @click="gotoBookings()">
        Go to bookings
      </IconButton>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import { mapGetters } from "vuex";

export default {
  data: function () {
    return {
      bookings: {
        new: { totalCount: 0 },
        assigned: { totalCount: 0 },
        delivered: { totalCount: 0 },
        cancelled: { totalCount: 0 },
      },
    };
  },

  methods: {
    gotoBookings() {
      this.$router.push({ name: "bookings" });
    },
  },

  computed: {
    ...mapGetters(["profile"]),

    ptId() {
      return this.profile.id;
    },
  },

  apollo: {
    bookings: {
      fetchPolicy: "no-cache",
      query: gql`
          query MyBookings($ptId: UUID!) {
            new: bookings(condition: { status: "NEW" }) {
              totalCount
            }
            assigned: bookings(condition: { status: "ASSIGNED", ptId: $ptId }) {
              totalCount
            }
            delivered: bookings(condition: { status: "DELIVERED", ptId: $ptId }) {
              totalCount
            }
            cancelled: bookings(condition: { status: "CANCELLED", ptId: $ptId }) {
              totalCount
            }
          }
      `,
      variables() {
        return { ptId: this.ptId };
      },
      update(data) {
        return data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.MyBookings {
  display: flex;
  flex-direction: column;

  h4 {
    text-transform: uppercase;
    padding-bottom: 3em;
  }

  .footer {
    display: flex;
    justify-content: flex-end;
  }

  .body {
    margin-bottom: auto;
  }

  .status {
    display: flex;
    justify-content: space-between;
    padding-bottom: 3em;

    .label {
      font-size: 1.142em;
      font-weight: bold;
      padding-right: 5em;
    }

    .count {
      color: white;
      padding: 0.5em;
      font-size: 0.857em;
      border-radius: 13px;
      padding-left: 3em;
      padding-right: 3em;
    }

    &.new {
      .label {
        color: var(--midnight-blue);
      }
      .count {
        background-color: var(--midnight-blue);
      }
    }
    &.assigned {
      .label {
        color: var(--blue-purple);
      }
      .count {
        background-color: var(--blue-purple);
      }
    }
    &.completed {
      .label {
        color: var(--dark-seafoam);
      }
      .count {
        background-color: var(--dark-seafoam);
      }
    }
    &.cancelled {
      .label {
        color: var(--pinkish-red);
      }
      .count {
        background-color: var(--pinkish-red);
      }
    }
  }
}
</style>
